import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  TextField
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = (theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  actions: {
    justifyContent: 'flex-end'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  }
})

class TitleForm extends Component {
  componentDidMount(){
    console.log('selectedId', this.props.selectedId)
  }

  render() {
    const { classes } = this.props;

    return(
      <Card
        className={clsx(classes.root, this.props.className)}
      >
        <CardHeader title='Title' />
        <Divider />
        <CardContent className={classes.cardContent}>
          <TextField
            label="Name"
            variant="outlined"
            name='name'
            value={this.props.name}
            onChange={this.props.onChange}
          />
          {this.props.errorMessage.map((message, index) => { return(<span key={index}>{message}</span>) })}
        </CardContent>
        <Divider />
        <CardActions>
          <Button onClick={this.props.onClose}>Close</Button>
          <Button color="primary" variant="contained" type='submit'>Save</Button>
        </CardActions>
      </Card>
    )
  }
}

class EditTitle extends Component {
  state = {
    titleId: null,
    open: false,
    errorMessage: [],
    name: '',
  }

  componentDidMount() {
    this.props.handleDataItemFetch(this.props.adminUserSession, `/v1/admin/titles/${this.props.selectedId}/edit`)
      .then(() => {
        const { title } = this.props.adminFetchItem;

        this.setState({
          name: title.name,
          titleId: title.id,
        })
      })
  }

  handleOnChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  hadleOpen = (event, open) => {
    this.setState({
      open
    })
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const selected = this.props.selected;

    this.props.handleProcessItem(this.props.adminUserSession, `/v1/admin/titles/${this.state.titleId}`, { title: { name: this.state.name } })
      .then(() => {
        if (this.props.adminUpdateItem.status == 'ok') {
          this.props.itemChange(selected, this.state.name);
          this.props.onClose();
        } else {
          this.setState({
            errorMessage: this.props.adminUpdateItem.message.name,
          });
        }
      });
  }

  render() {
    return(
      <Modal
        onClose={this.props.onClose}
        open={this.props.open}
      >
        <form onSubmit={this.handleSubmit}>
          <TitleForm selectedId={this.props.selectedId} classes={this.props.classes} errorMessage={this.state.errorMessage} name={this.state.name} onClose={this.props.onClose} onChange={this.handleOnChange}  />
        </form>
      </Modal>
    )
  }
}

class NewTitle extends Component {
  state = {
    open: false,
    errorMessage: [],
    name: '',
  }

  handleOnChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  componentDidMount() {
    console.log('new', this.props)
  }

  hadleOpen = (event, open) => {
    this.setState({
      open
    })
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.props.handleCreateTitle(this.props.adminUserSession, '/v1/admin/titles', { title: { name: this.state.name } })
      .then(() => {
        console.log('JOLA', this.props.adminCreateTitle);

        if (this.props.adminCreateTitle.status == 'ok') {
          this.props.onClose(this.props.adminCreateTitle.title);
        } else {
          this.setState({
            errorMessage: this.props.adminCreateTitle.message.name,
          });
        }
      });

    console.log('create', this.props)

    console.log('submit', this.state)
  }

  render() {
    return(
      <Modal
        onClose={this.props.onClose}
        open={this.props.open}
      >
        <form onSubmit={this.handleSubmit}>
          <TitleForm classes={this.props.classes} errorMessage={this.state.errorMessage} name={this.state.name} onClose={this.props.onClose} onChange={this.handleOnChange} />
        </form>
      </Modal>
    )
  }
}

NewTitle.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
};

EditTitle.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
};

const NewTitleWithStyles = withStyles(styles)(NewTitle);
const EditTitleWithStyles = withStyles(styles)(EditTitle);

export { NewTitleWithStyles, EditTitleWithStyles };